import { Injectable } from '@angular/core';
import { FULLY_UNAUTHENTICATED_APIS } from '../constants/unauthenticated-apis';
import { TokenService } from '../contracts/token-service.contract';
import { TokenRefreshedResponse } from '../models/ApiResponse';
import { RestApiException, RestApiService } from '../stubs/rest-api-service.stub';

export abstract class TokenException extends RestApiException {}

/**
 * Provides methods to interact with authentication tokens using
 * API endpoints.
 */
@Injectable()
export class ApiTokenService extends RestApiService implements TokenService {
  /**
   * Refreshes the user's token and returns the new set of tokens.
   *
   * @throws InvalidTokenException
   * @throws PasswordResetRequiredException
   * @throws UserNotFoundException
   *
   * @param userUri The URI of the user, to which the token belongs.
   * @param refreshToken The currently valid refresh token
   */
  public async refreshToken(userUri: string, refreshToken: string): Promise<TokenRefreshedResponse> {
    try {
      //Using fetch api instead of httpClient to avoid HttpInterceptor circular dependency
      const response: Response = await fetch(`${this.restUrl}${FULLY_UNAUTHENTICATED_APIS.AUTH_REFRESH_URI}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userUri,
          refreshToken
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data: TokenRefreshedResponse = await response.json();
      return data;
    } catch (error) {
      this.convertToException(error);
    }
  }
}
